import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import PendingApproval from "./components/PendingApproval";
import BannedScreen from "./components/BannedScreen";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import Chat from "./pages/Chat";
import Members from "./pages/Members";
import Profile from "./pages/Profile";
import Admin from "./pages/Admin";
import PrivateMessages from "./pages/PrivateMessages";
import Friends from "./pages/Friends";
import Verlosung from "./pages/Verlosung";
import Home from "./pages/Home";
import Live from "./pages/Live";
import Leaderboard from "./pages/Leaderboard";
import Support from "./pages/Support";

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F8FD] text-slate-600">
      Lade…
    </div>
  );
}

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.banned) return <BannedScreen />;
  if (!user.is_approved && user.role !== "admin") return <PendingApproval />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/chat" replace />;
  return <Layout>{children}</Layout>;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <FullScreenLoader />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/passwort-vergessen" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
            <Route path="/chat" element={<Protected><Chat /></Protected>} />
            <Route path="/live" element={<Protected><Live /></Protected>} />
            <Route path="/rangliste" element={<Protected><Leaderboard /></Protected>} />
            <Route path="/nachrichten" element={<Protected><PrivateMessages /></Protected>} />
            <Route path="/nachrichten/:userId" element={<Protected><PrivateMessages /></Protected>} />
            <Route path="/freunde" element={<Protected><Friends /></Protected>} />
            <Route path="/verlosung" element={<Protected><Verlosung /></Protected>} />
            <Route path="/mitarbeiter" element={<Protected><Support /></Protected>} />
            <Route path="/mitglieder" element={<Protected><Members /></Protected>} />
            <Route path="/profil" element={<Protected><Profile /></Protected>} />
            <Route path="/admin" element={<Protected adminOnly><Admin /></Protected>} />
            <Route path="/" element={<Protected><Home /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: {
              background: "#FFFFFF",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "white",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}
